import React, { useEffect, useRef } from 'react';
import { Animated } from 'react-native';

const FadeInAnimation = ({ delay = 0, duration = 1000, children }) => {
  // Create an animated value for opacity (starts at 0)
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    // Trigger the fade-in animation with the specified delay and duration
    Animated.timing(fadeAnim, {
      toValue: 1, // Fade to full opacity
      duration, // Duration of the animation
      delay, // Delay before the animation starts
      useNativeDriver: true, // Use native driver for performance
    }).start();
  }, [fadeAnim, delay, duration]);

  // Apply the animated opacity to the children components
  return (
    <Animated.View style={{ opacity: fadeAnim }}>{children}</Animated.View>
  );
};

export default FadeInAnimation;
